import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, mergeProps as _mergeProps, resolveDirective as _resolveDirective, createElementBlock as _createElementBlock, withDirectives as _withDirectives, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["href", "onClick"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "text-900 font-medium text-xl mb-3" }, "Response Log", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "m-0 mb-4 p-0 text-600 line-height-3 mr-3" }, "A log of your all responses received to this campaign.", -1)
const _hoisted_4 = { class: "surface-card p-4 shadow-2 border-round" }
const _hoisted_5 = { class: "grid formgrid p-fluid" }
const _hoisted_6 = { class: "field mb-4 col-12" }
const _hoisted_7 = {
  key: 0,
  class: "m-0 mb-4 p-0 text-600 line-height-3 mr-3"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_spinner = _resolveComponent("spinner")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_TabMenu = _resolveComponent("TabMenu")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_ScrollPanel = _resolveComponent("ScrollPanel")!
  const _directive_ripple = _resolveDirective("ripple")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.contactsLoading || _ctx.responsesLoading || _ctx.messagesLoading)
      ? (_openBlock(), _createBlock(_component_spinner, { key: 0 }))
      : _createCommentVNode("", true),
    _createVNode(_component_TabMenu, {
      activeIndex: _ctx.active,
      "onUpdate:activeIndex": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.active) = $event)),
      model: _ctx.tabItems,
      class: "mb-4"
    }, {
      item: _withCtx(({ item, props }) => [
        _createVNode(_component_router_link, {
          to: { name: item.route },
          custom: ""
        }, {
          default: _withCtx(({ href, navigate }) => [
            _withDirectives((_openBlock(), _createElementBlock("a", _mergeProps({ href: href }, props.action, { onClick: navigate }), [
              _createElementVNode("span", _normalizeProps(_guardReactiveProps(props.icon)), null, 16),
              _createElementVNode("span", _normalizeProps(_guardReactiveProps(props.label)), _toDisplayString(item.label), 17)
            ], 16, _hoisted_1)), [
              [_directive_ripple]
            ])
          ]),
          _: 2
        }, 1032, ["to"])
      ]),
      _: 1
    }, 8, ["activeIndex", "model"]),
    _createVNode(_component_ScrollPanel, { style: {"width":"100%","height":"78vh"} }, {
      default: _withCtx(() => [
        _hoisted_2,
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              (!_ctx.responseLog.length)
                ? (_openBlock(), _createElementBlock("p", _hoisted_7, " You have not received any responses yet. "))
                : (_openBlock(), _createBlock(_component_DataTable, {
                    key: 1,
                    value: _ctx.responseLog,
                    scrollable: "",
                    scrollHeight: "600px",
                    stripedRows: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_Column, {
                        field: "from",
                        header: "Respondent",
                        sortable: ""
                      }),
                      _createVNode(_component_Column, {
                        field: "phoneNumber",
                        header: "Phone Number"
                      }),
                      _createVNode(_component_Column, {
                        field: "response",
                        header: "Response"
                      }),
                      _createVNode(_component_Column, {
                        field: "respondingTo",
                        header: "Responding To",
                        sortable: ""
                      }),
                      _createVNode(_component_Column, {
                        field: "timeToRespond",
                        header: "Time To Respond",
                        sortable: ""
                      })
                    ]),
                    _: 1
                  }, 8, ["value"]))
            ])
          ])
        ])
      ]),
      _: 1
    })
  ], 64))
}